<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IkW0h4/tc-custom/9781398411272.jpg?1692135053458" alt="This image is the cover for the book The Watermouse Family – Book 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Watermouse Family – Book 2
      </h1>
      <p class="bookDescription body article font2">
        <p>On Wednesday Daddy usually goes to the woods to collect the fruit for Nan to make the pies for the family shop, but today he is sick. Little Toby wants to help and goes to the woods by himself. While he is there, he learns that friends can come in all shapes and sizes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dean Fitzgerald
      </h2>
      
      <p class="authorDescription body article">Dean Fitzgerald loved to write stories as a child but grew up to be an accountant. After the death of his grandmother and recovering from a long and misdiagnosed illness, he found some of the old stories and decided to share them with the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d3435528